import cartForm from "../components/cart/cartForm";
import selects from "../components/selects";
import "../sections/pdp-carousel";

const pdp = (() => {
  const SELECTOR_SLIDESHOW = ".js-productSlideshow";
  const SELECTOR_RECS = ".js-productRecs";
  const SELECTOR_GRID = ".js-productGrid";
  const SELECTOR_SMOOTH_SCROLL = ".js-smoothScroll";
  const SELECTOR_MORE_CARD = ".js-productMoreCard";

  const SELECTOR_MODAL = ".js-productModal";
  const SELECTOR_MODAL_CONT = ".js-productModalContainer";
  const SELECTOR_MODAL_TOGGLE = ".js-productModalToggle";
  const SELECTOR_MODAL_DD = ".js-modalDD";
  const SELECTOR_MODAL_DD_TOGGLE = ".js-modalDDToggle";

  const SELECTOR_DESCRIPTION_TOGGLES = ".heading";
  const SELECTOR_DESCRIPTION_TOGGLES_MOBILE = ".mobile-heading";

  function smoothScroll(ev) {
    ev.preventDefault();
    const href = ev.currentTarget.getAttribute("href");
    document.querySelector(href).scrollIntoView({
      behavior: "smooth",
    });
  }

  function toggleModal(ev) {
    ev.preventDefault();
    const elToggle = ev.currentTarget;
    const elModal = elToggle
      .closest(SELECTOR_MODAL_CONT)
      .querySelector(SELECTOR_MODAL);
    const elModals = document.querySelectorAll(SELECTOR_MODAL);

    elModals.forEach((el) => {
      el !== elModal
        ? el.classList.add("hidden")
        : el.classList.toggle("hidden");
    });
  }

  function onDDToggleClick({ currentTarget }) {
    let activeDD = currentTarget.parentNode;
    console.log(activeDD);
    toggleSizeGuideDD(activeDD);
  }

  function toggleSizeGuideDD(activeDD) {
    const elDropdowns = document.querySelectorAll(SELECTOR_MODAL_DD);
    elDropdowns.forEach((el) => {
      if (el !== activeDD) {
        el.classList.remove("active");
      } else {
        el.classList.toggle("active");
      }
    });
  }

  function changeVariant(ev) {
    ev.preventDefault();
    const elCard = ev.currentTarget;
    let color = elCard.getAttribute("data-color");

    const elSelect = document.getElementById(`select-color`);
    const elOptions = elSelect.parentNode.querySelectorAll(".select__option");
    const elSelectValue = elSelect.parentNode.querySelector(".select__value");

    elSelect.value = color;
    selects.changeUi(elOptions, color, elSelect, elSelectValue);
  }

  function setInitialDescHeight() {
    // console.log('setting height rn');
    let contents = document.querySelector('.product-description-contents')
    let mobileContents = document.querySelector('.product-description-contents--mobile')
    let contentEls = contents.querySelectorAll('.content')
    let mobileContentEls = mobileContents.querySelectorAll('.content')
    contents.style.height = contentEls[0].offsetHeight + "px";
    mobileContents.style.height = mobileContentEls[0].offsetHeight + "px";
  }

  function onDescriptionClick(ev) {
    ev.preventDefault();
    let headings = document.querySelector('.product-description-headings')
    let headingEls = headings.querySelectorAll('.heading')

    let contents = document.querySelector('.product-description-contents')
    let contentEls = contents.querySelectorAll('.content')

    headingEls.forEach((el, i) => {
      if (el == ev.currentTarget) {
        contentEls[i].style.opacity = "1.0";
        headingEls[i].classList.add('active');
        contents.style.height = contentEls[i].offsetHeight + "px";
      } else {
        contentEls[i].style.opacity = "0"
        headingEls[i].classList.remove('active');
      }
    })
  }

  function onMobileDescClick(ev) {
    console.log(ev)
    ev.preventDefault();
    let headingsMobile = document.querySelector('.product-description-headings--mobile')
    let headingElsMobile = headingsMobile.querySelectorAll('.mobile-heading')

    let mobileContents = document.querySelector('.product-description-contents--mobile')
    let mobileContentEls = mobileContents.querySelectorAll('.content')

    headingElsMobile.forEach((el, i) => {
      if (el == ev.currentTarget) {
        mobileContentEls[i].style.opacity = "1.0";
        headingElsMobile[i].classList.add('active');
        mobileContents.style.height = mobileContentEls[i].offsetHeight + "px";
      } else {
        mobileContentEls[i].style.opacity = "0"
        headingElsMobile[i].classList.remove('active');
      }
    })
  }

  function bind() {
    // setInitialDescHeight();
    // Rush changed because was sometimes calculating height at the wrong time
    window.onload = function () {
      setInitialDescHeight();
      let productCartForm = document.querySelector('.product-cart-form');
      let desktopLumeSelector = document.querySelector('.lume-selector');
      if(productCartForm){
        productCartForm.classList.add('loaded');
        console.log('setting product cart form height');
      }
      if(desktopLumeSelector){
        desktopLumeSelector.classList.add('loaded');
        console.log('setting lume cart form height');
      }
    }
    window.addEventListener('resize', setInitialDescHeight);

    const descriptionToggles = document.querySelectorAll(SELECTOR_DESCRIPTION_TOGGLES);
    Array.prototype.forEach.call(descriptionToggles, (el) => {
      el.removeEventListener("click", onDescriptionClick);
      el.addEventListener("click", onDescriptionClick);
    });

    const mobileDescriptionToggles = document.querySelectorAll(SELECTOR_DESCRIPTION_TOGGLES_MOBILE);
    Array.prototype.forEach.call(mobileDescriptionToggles, (el) => {
      el.removeEventListener("click", onMobileDescClick);
      el.addEventListener("click", onMobileDescClick);
    });

    const elsSmooth = document.querySelectorAll(SELECTOR_SMOOTH_SCROLL);
    Array.prototype.forEach.call(elsSmooth, (el) => {
      el.removeEventListener("click", smoothScroll);
      el.addEventListener("click", smoothScroll);
    });

    const elModalToggle = document.querySelectorAll(SELECTOR_MODAL_TOGGLE);
    Array.prototype.forEach.call(elModalToggle, (el) => {
      el.removeEventListener("click", toggleModal);
      el.addEventListener("click", toggleModal);
    });

    const elModalDDToggle = document.querySelectorAll(SELECTOR_MODAL_DD_TOGGLE);
    Array.prototype.forEach.call(elModalDDToggle, (el) => {
      el.removeEventListener("click", onDDToggleClick);
      el.addEventListener("click", onDDToggleClick);
    });

    const elMoreCards = document.querySelectorAll(SELECTOR_MORE_CARD);
    Array.prototype.forEach.call(elMoreCards, (el) => {
      el.removeEventListener("click", changeVariant);
      el.addEventListener("click", changeVariant);
    });
  }

  // RUSH LUME CODE (ADDED 9/2/25)
  const lumeSelector = document.querySelector('.lume-selector');
  const lumeSelectorMobile = document.querySelector('.lume-selector--mobile');
  

  if(lumeSelector){
    const lumeDay = lumeSelector.querySelector('#lumeDay');
    const lumeNight = lumeSelector.querySelector('#lumeNight');
    lumeDay.addEventListener('click', () => {
      const origImageEl = document.getElementById('imageToSwap');
      const selectEl = document.getElementById('strap-type');
      const selectedOptionImage = selectEl.options[selectEl.selectedIndex].id;
      lumeSelector.classList.remove('night-active');
      origImageEl.src = selectedOptionImage;
    })
    lumeNight.addEventListener('click', () => {
      const origImageEl = document.getElementById('imageToSwap');
      lumeSelector.classList.add('night-active');
      origImageEl.src = lumeNight.dataset.img;
    })
  }

  if(lumeSelectorMobile){
    const lumeDay = lumeSelectorMobile.querySelector('#lumeDay');
    const lumeNight = lumeSelectorMobile.querySelector('#lumeNight');
    lumeDay.addEventListener('click', () => {
      const origImageEl = document.getElementById('imageToSwap');
      const selectEl = document.getElementById('strap-type');
      const selectedOptionImage = selectEl.options[selectEl.selectedIndex].id;
      lumeSelectorMobile.classList.remove('night-active');
      origImageEl.src = selectedOptionImage;
    })
    lumeNight.addEventListener('click', () => {
      const origImageEl = document.getElementById('imageToSwap');
      lumeSelectorMobile.classList.add('night-active');
      origImageEl.src = lumeNight.dataset.img;
    })
  }

  /********************/

  function init() {
    bind();
    cartForm.init();
  }

  return {
    init,
  };
})();

export default pdp;
